import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'toast-banner',
  templateUrl: './toast-banner.component.html',
  styleUrls: ['./toast-banner.component.scss'],
  standalone: false,
})
export class ToastBannerComponent {
  public eventSubject = new Subject<boolean>();
  public buttonTitle = 'Cancel';
  public message = '';

  public onClose(): void {
    this.eventSubject.next(true);
  }
}
